import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../../_services/';

// import * as firebase from 'firebase/app'; // Typescript
// // import firebase from 'firebase/app'; // JS
// import 'firebase/functions';

import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-claim-marketing-list-entry',
  templateUrl: './claim-marketing-list-entry.component.html',
  styleUrls: ['./claim-marketing-list-entry.component.scss'],
  providers : [AngularFireFunctions]
})
export class ClaimMarketingListEntryComponent implements OnInit {
  MLEntryId:string;
  errMsg:string;
  constructor(
    private _route: ActivatedRoute,
    private fns : AngularFireFunctions,
    private _common: CommonService
  ) { }

  ngOnInit() {
    this._route.paramMap.subscribe(params => {
      this.MLEntryId = params.get("id"); 
    })
    
    this.claimMarketingListEntry();

  }

  claimMarketingListEntry(){
    this._common.showLoader(true);
    if(window.location.host.includes('localhost')){
      this.fns.functions.useFunctionsEmulator('http://localhost:5000');
    }
    
    const claimMarketingListEntry = this.fns.httpsCallable('claim_marketing_list_entry');
    claimMarketingListEntry({marketing_list_entry_id: this.MLEntryId, owner_contact_id: localStorage.getItem('contactId')}).subscribe((result) => {
      this._common.showLoader(false);
      if(result.outcome==="success"){
        this._common.navigate ('contact/'+result.contact_id);
      }
      else {
        this.errMsg = result.message;
      }
    },err=>{
      console.log(JSON.stringify(err),'this is testing error!!!!!');
    });
  }

}
